import { HOST_URL } from 'config';

const BaseUrl = '/WebApp/';
const BaseUrlGlobalMode = '/WebAppGlobal/';

const Controller = {
  Account: 'Account/',
  Report: 'Report/',
  Settings: 'Settings/',
  SettingsDecoy: 'SettingsDecoy/',
  ThreatHunting: 'SettingsThreatHunting/',
  /**SettingsWhitelist/ */
  SettingsWhitelisting: 'SettingsWhitelist/',
  SettingsExclusion: 'SettingsExclusion/',
  WindowsEventsProfile: 'WindowsEventsProfile/',
  StorageDevicesProfile: 'StorageDevicesProfile/',
  SettingsFileMonitor: 'SettingsFileMonitor/',
  Remediation: 'Remediation/',
  CustomRemediation: 'CustomRemediation/',
  Vault: 'Vault/',
  PlayBooks: 'PlayBooks/',
  CustomRemediationExecutionServers: 'CustomRemediationExecutionServers/',
  SettingsEPSCertificates: 'SettingsEPSCertificates/',
  Actions: 'Actions/',
  Hosts: 'Hosts/',
  Files: 'Files/',
  Users: 'Users/',
  Network: 'Network/',
  Exports: 'Exports/',
  WindowsEvents: 'WindowsEvents/',
  DeceptionUser: 'DeceptionUser/',
  SettingsDecoyNetwork: 'SettingsDeceptionNetwork/',
  Search: 'Search/',
  CisoKit: 'CisoKit/',
  Alerts: 'Alerts/',
  Arp: 'Arp/',
  Scanner: 'Scanner/',
  Object: 'Object/',
  ClientSettings: 'ClientSettings/',
  SettingsScanGroups: 'SettingsScanGroups/',
  SettingsAlerts: 'SettingsAlerts/',
  WebProxySettings: 'WebProxySettings/',
  Billing: 'Billing/',
  ClientLogger: 'ClientLogger/',
  PlantingUIjs: 'PlantingUIjs/',
  Customers: 'Customers/',
  ExternalIntegration: 'ExternalIntegration/'
};

export const ApiEndPoints = {
  Account: {
    Logout: HOST_URL + BaseUrl + Controller.Account + 'LogOut'
  },
  Arp: {
    AddOrEditComment: HOST_URL + BaseUrl + Controller.Arp + 'AddOrEditComment'
  },
  Alerts: {
    GetAllComment: HOST_URL + BaseUrl + Controller.Alerts + 'GetAllComment',
    AddComment: HOST_URL + BaseUrl + Controller.Alerts + 'AddComment',
    AddComments: HOST_URL + BaseUrl + Controller.Alerts + 'AddComments',
    CountOpenAlerts: HOST_URL + BaseUrl + Controller.Alerts + 'CountOpenAlerts',
    GetIncidentById: HOST_URL + BaseUrl + Controller.Alerts + 'GetIncidentById',
    GetIncidentByPlaybookId: HOST_URL + BaseUrl + Controller.Alerts + 'GetIncidentByPlaybookId',
    GetIncidentArtifactsByIncidentId: HOST_URL + BaseUrl + Controller.Alerts + 'GetIncidentArtifactsByIncidentId',
    GetIncidentSummaryBlocksByIncidentId:
      HOST_URL + BaseUrl + Controller.Alerts + 'GetIncidentSummaryBlocksByIncidentId',
    GetIncidentAdvancedArtifactsByIncidentId:
      HOST_URL + BaseUrl + Controller.Alerts + 'GetIncidentAdvancedArtifactsByIncidentId',
    AddIncidentManualRemediationByIncidentAndNodeId:
      HOST_URL + BaseUrl + Controller.Alerts + 'AddIncidentManualRemediationByIncidentAndNodeId'
  },
  Report: {
    GetAlertStatusByDates: HOST_URL + BaseUrl + Controller.Report + 'AlertStatusByDates',
    SearchAlerts: HOST_URL + BaseUrl + Controller.Report + 'SearchAlerts',
    GetRadarTop10Alerts: HOST_URL + BaseUrl + Controller.Report + 'RadarTop10Alerts',
    GetAlertCountByEntity: HOST_URL + BaseUrl + Controller.Report + 'AlertCountByEntity',
    GetFileScannedByDates: HOST_URL + BaseUrl + Controller.Report + 'FileScannedByDays',
    GetWhiteListedFilesInDates: HOST_URL + BaseUrl + Controller.Report + 'WhiteListedFilesCountBetweenDates',
    GeneratePDF: HOST_URL + BaseUrl + Controller.Report + 'GeneratePDF',
    ExportVAExcel: HOST_URL + BaseUrl + Controller.Report + 'GenerateVAReport',
    ExportInventoryExcel: HOST_URL + BaseUrl + Controller.Report + 'GenerateInventoryReport',
    GetAdvancedReportsList: HOST_URL + BaseUrl + Controller.Report + 'GetAdvancedReportsList',
    GetAdvancedReportsConfiguration: HOST_URL + BaseUrl + Controller.Report + 'GetAdvancedReportsConfiguration',
    GetAdvancedReportsSchedulesList: HOST_URL + BaseUrl + Controller.Report + 'GetAdvancedReportsSchedulesList',
    RemoveAdvancedReportsSchedule: HOST_URL + BaseUrl + Controller.Report + 'RemoveAdvancedReportsSchedule'
  },
  ProxyDetails: {
    GetUserId: '/SitePages/Users/Details.aspx?id=',
    GetHostId: '/SitePages/Hosts/Details.aspx?id='
  },
  Object: {
    GetRelatedEntitiesObjects: HOST_URL + BaseUrl + Controller.Object + 'GetRelatedEntitiesObjects',
    GetObjectProperties: HOST_URL + BaseUrl + Controller.Object + 'GetObjectProperties'
  },
  HostDetails: {},
  Settings: {
    GetActiveDirectoryGroups: HOST_URL + BaseUrl + Controller.Settings + 'GetAdGroups',
    GetActiveDirectoryGroupsByDomain: HOST_URL + BaseUrl + Controller.Settings + 'GetAdGroupsByDomain',
    GetEnabledADIdentities: HOST_URL + BaseUrl + Controller.Settings + 'GetEnabledADIdentities',
    RemoveEnabledADIdentity: HOST_URL + BaseUrl + Controller.Settings + 'RemoveEnabledADIdentity',
    AddEnabledADIdentity: HOST_URL + BaseUrl + Controller.Settings + 'AddEnabledADIdentities',
    GetActiveDirectoryConnections: HOST_URL + BaseUrl + Controller.Settings + 'GetADSerivces',
    AddActiveDirectoryConnections: HOST_URL + BaseUrl + Controller.Settings + 'AddADSerivce',
    RemoveActiveDirectoryConnections: HOST_URL + BaseUrl + Controller.Settings + 'RemoveADSerivce',
    UpdateActiveDirectoryConnections: HOST_URL + BaseUrl + Controller.Settings + 'UpdateADSerivce',
    GetAuthenticationMode: HOST_URL + BaseUrl + Controller.Settings + 'GetAuthenticationMode',
    SetAuthenticationMode: HOST_URL + BaseUrl + Controller.Settings + 'SetAuthenticationMode',
    GetSupportedHosts: HOST_URL + BaseUrl + Controller.Settings + 'GetSupportedHosts',

    GetAdvancedSettings: HOST_URL + BaseUrl + Controller.Settings + 'GetAdvancedSettings',
    GetAllWebProxySettings: HOST_URL + BaseUrl + Controller.Settings + 'GetAllWebProxySettings',
    GetWebProxySettingsById: HOST_URL + BaseUrl + Controller.Settings + 'GetWebProxySettingsByIdAsync',
    CreateWebProxy: HOST_URL + BaseUrl + Controller.Settings + 'CreateWebProxyAsync',
    UpdateWebProxy: HOST_URL + BaseUrl + Controller.Settings + 'UpdateWebProxyAsync',
    DeleteWebProxy: HOST_URL + BaseUrl + Controller.Settings + 'DeleteWebProxyAsync',
    SaveAdvancedSettings: HOST_URL + BaseUrl + Controller.Settings + 'SaveAdvancedSettings',
    DeleteSlave: HOST_URL + BaseUrl + Controller.Settings + 'DeleteSlave',
    SaveSlave: HOST_URL + BaseUrl + Controller.Settings + 'SaveSlave',
    AddDomainWL: HOST_URL + BaseUrl + Controller.Settings + 'AddDomainWL',
    UpdateDomainWL: HOST_URL + BaseUrl + Controller.Settings + 'UpdateDomainWL',
    DeleteDomainWL: HOST_URL + BaseUrl + Controller.Settings + 'DeleteDomainWL',
    AddPolicyWildCard: HOST_URL + BaseUrl + Controller.Settings + 'AddPolicyWildCard',
    DeletePolicyWildCard: HOST_URL + BaseUrl + Controller.Settings + 'DeletePolicyWildCard',
    DeletePolicyWildCardById: HOST_URL + BaseUrl + Controller.Settings + 'DeletePolicyWildCardById',
    ChangePolicyWildCardById: HOST_URL + BaseUrl + Controller.Settings + 'ChangePolicyWildCardById',
    GetPolicies: HOST_URL + BaseUrl + Controller.Settings + 'GetPolicies',
    GetCustomEpsCertSettings: HOST_URL + BaseUrl + Controller.Settings + 'GetCustomEpsCertSettings',
    SaveCustomEpsCertSettings: HOST_URL + BaseUrl + Controller.Settings + 'SaveCustomEpsCertSettings',
    SetEpsUninstallPasswordSettings: HOST_URL + BaseUrl + Controller.Settings + 'SetEpsUninstallPasswordSettings',
    GetMfaStatusByUserId: HOST_URL + BaseUrl + Controller.Settings + 'GetMfaStatusByUserId',
    ChangeUserMfaSettings: HOST_URL + BaseUrl + Controller.Settings + 'ChangeUserMfaSettings',

    //integrations
    GetS3Settings: HOST_URL + BaseUrl + Controller.Settings + 'GetS3Settings',
    GetS3BucketSettings: HOST_URL + BaseUrl + Controller.Settings + 'GetS3BucketSettings',
    AddS3Settings: HOST_URL + BaseUrl + Controller.Settings + 'AddS3Settings',
    AddS3BucketSettings: HOST_URL + BaseUrl + Controller.Settings + 'AddS3BucketSettings',
    UpdateS3Settings: HOST_URL + BaseUrl + Controller.Settings + 'UpdateS3Settings',
    UpdateS3BucketSettings: HOST_URL + BaseUrl + Controller.Settings + 'UpdateS3BucketSettings',
    RemoveS3Settings: HOST_URL + BaseUrl + Controller.Settings + 'RemoveS3Settings',
    RemoveS3BucketSettings: HOST_URL + BaseUrl + Controller.Settings + 'RemoveS3BucketSettings',
    AddS3SettingsToBucketSettings: HOST_URL + BaseUrl + Controller.Settings + 'AddS3SettingsToBucketSettings',
    GetS3SettingsToBucketSettings: HOST_URL + BaseUrl + Controller.Settings + 'GetS3SettingsToBucketSettings',
    RemoveS3SettingsToBucketSettings: HOST_URL + BaseUrl + Controller.Settings + 'RemoveS3SettingsToBucketSettings',

    //External Integration End-points
    GetExternalIntegration: HOST_URL + BaseUrl + Controller.ExternalIntegration + 'GetIntegrations',
    SaveExternalSettings: HOST_URL + BaseUrl + Controller.ExternalIntegration + 'SaveSettings',
    GetExternalSettings: HOST_URL + BaseUrl + Controller.ExternalIntegration + 'GetSettings',
    ConnectivityTest: HOST_URL + BaseUrl + Controller.ExternalIntegration + 'ConnectivityTest',
    BillingConnectivityTest: HOST_URL + BaseUrl + Controller.ExternalIntegration + 'BillingConnectivityTest',
    ConnectivityTestByKey: HOST_URL + BaseUrl + Controller.ExternalIntegration + 'ConnectivityTestByKey',
    SetExternalIntegrationEnabled: HOST_URL + BaseUrl + Controller.ExternalIntegration + 'SetIntegrationEnabled',
    GetExternalIntegrationEnabled: HOST_URL + BaseUrl + Controller.ExternalIntegration + 'GetIntegrationEnabled',

    //configuration
    GetExcludedIpRanges: HOST_URL + BaseUrl + Controller.Settings + 'GetExcludedIpRanges',
    GetExcludedHostNames: HOST_URL + BaseUrl + Controller.Settings + 'GetExcludedHostNames',
    DeleteExcludedIpRenage: HOST_URL + BaseUrl + Controller.Settings + 'DeleteExcludedIpRenage',
    DeleteExcludedHostNames: HOST_URL + BaseUrl + Controller.Settings + 'DeleteExcludedHostNames',
    AddIpRangeToExclude: HOST_URL + BaseUrl + Controller.Settings + 'AddIpRangeToExclude',
    AddHostNameToExclude: HOST_URL + BaseUrl + Controller.Settings + 'AddHostNameToExclude',
    GetProxyParsers: HOST_URL + BaseUrl + Controller.Settings + 'GetProxyParsers',
    EditProxyParser: HOST_URL + BaseUrl + Controller.Settings + 'EditProxyParser',
    AddProxyParser: HOST_URL + BaseUrl + Controller.Settings + 'AddProxyParser',
    GetProxyParserByName: HOST_URL + BaseUrl + Controller.Settings + 'GetProxyParserByName',
    GetFoldersByType: HOST_URL + BaseUrl + Controller.Settings + 'GetFoldersByType',
    GetFolderByName: HOST_URL + BaseUrl + Controller.Settings + 'GetFolderByName',
    AddFolder: HOST_URL + BaseUrl + Controller.Settings + 'AddFolder',
    EditFolder: HOST_URL + BaseUrl + Controller.Settings + 'EditFolder',
    DeleteFolder: HOST_URL + BaseUrl + Controller.Settings + 'DeleteFolder',
    VerifyProxyParser: HOST_URL + BaseUrl + Controller.Settings + 'VerifyProxyParser',
    DeleteParser: HOST_URL + BaseUrl + Controller.Settings + 'DeleteParser',
    GetVpnParsers: HOST_URL + BaseUrl + Controller.Settings + 'GetVpnParsers',
    EditVpnParser: HOST_URL + BaseUrl + Controller.Settings + 'EditVpnParser',
    AddVpnParser: HOST_URL + BaseUrl + Controller.Settings + 'AddVpnParser',
    GetVpnParserByName: HOST_URL + BaseUrl + Controller.Settings + 'GetVpnParserByName',
    VerifyVpnParser: HOST_URL + BaseUrl + Controller.Settings + 'VerifyVpnParser',
    GetTvModeToken: HOST_URL + BaseUrl + Controller.Settings + 'GetTvModeToken',
    SaveTvModeToken: HOST_URL + BaseUrl + Controller.Settings + 'SaveTvModeToken',
    GetElasticSearchServerConfiguration:
      HOST_URL + BaseUrl + Controller.Settings + 'GetElasticSearchServerConfiguration',
    UpdateElasticSearchServerConfiguration:
      HOST_URL + BaseUrl + Controller.Settings + 'UpdateElasticSearchServerConfiguration',
    TestElasticSearchServerConfiguration:
      HOST_URL + BaseUrl + Controller.Settings + 'TestElasticSearchServerConfiguration',

    GetSyslogSettings: HOST_URL + BaseUrl + Controller.Settings + 'GetSyslogSettings',
    AddSyslogSettings: HOST_URL + BaseUrl + Controller.Settings + 'AddIPSettingsToSyslogSettings',
    DeleteSyslogSettings: HOST_URL + BaseUrl + Controller.Settings + 'DeleteIPSettings',

    SaveDateTimeSettings: HOST_URL + BaseUrl + Controller.Settings + 'SaveDateTimeSettings',

    GetMapsData: HOST_URL + BaseUrl + Controller.Settings + 'GetMapsData',
    UpdateMap: HOST_URL + BaseUrl + Controller.Settings + 'UpdateMap',
    RemoveMap: HOST_URL + BaseUrl + Controller.Settings + 'RemoveMap',
    UploadNewMapImg: HOST_URL + BaseUrl + Controller.Settings + 'UploadNewMapImg',
    GetRegionMapData: HOST_URL + BaseUrl + Controller.Settings + 'GetRegionMapData',
    AddNewMapRange: HOST_URL + BaseUrl + Controller.Settings + 'AddNewMapRange',
    RemoveMapRange: HOST_URL + BaseUrl + Controller.Settings + 'RemoveMapRange',
    UpdateExistingMapRange: HOST_URL + BaseUrl + Controller.Settings + 'UpdateExistingMapRange',

    SaveADConfigurations: HOST_URL + BaseUrl + Controller.Settings + 'SaveADConfigurations',
    SaveCsvParser: HOST_URL + BaseUrl + Controller.Settings + 'saveCsvParser',
    UploadUsersCsvFile: HOST_URL + BaseUrl + Controller.Settings + 'UploadUsersCsvFile',
    GetAdAndCsvParsersConfigurations: HOST_URL + BaseUrl + Controller.Settings + 'GetAdAndCsvParsersConfigurations',
    DeleteADParser: HOST_URL + BaseUrl + Controller.Settings + 'DeleteADParser',

    HasEditSettingsPermissions: HOST_URL + BaseUrl + Controller.Settings + 'HasEditSettingsPermissions',
    GetGlobalSettings: HOST_URL + BaseUrl + Controller.Settings + 'GetGlobalSettings',
    GetProtectionProfiles: HOST_URL + BaseUrl + Controller.Settings + 'GetProtectionProfiles',
    IsMfaEnabled: HOST_URL + BaseUrl + Controller.Settings + 'IsMfaEnabled',
    IsAddUsernameInEmailFormat: HOST_URL + BaseUrl + Controller.Settings + 'IsAddUsernameInEmailFormat',
    GetScanGroupDetails: HOST_URL + BaseUrl + Controller.Settings + 'GetScanGroupDetails',
    GetScanGroups: HOST_URL + BaseUrl + Controller.Settings + 'GetScanGroups',
    GetScanAccounts: HOST_URL + BaseUrl + Controller.Settings + 'GetScanAccounts',
    GetScanAccount: HOST_URL + BaseUrl + Controller.Settings + 'GetScanAccount',
    SaveGroupInformation: HOST_URL + BaseUrl + Controller.Settings + 'SaveGroupInformation',
    DeleteGroup: HOST_URL + BaseUrl + Controller.Settings + 'DeleteGroup',
    RemoveAccount: HOST_URL + BaseUrl + Controller.Settings + 'RemoveAccount',
    AddGroup: HOST_URL + BaseUrl + Controller.Settings + 'AddGroup',
    AddAccount: HOST_URL + BaseUrl + Controller.Settings + 'AddAccount',
    UpdateAccount: HOST_URL + BaseUrl + Controller.Settings + 'UpdateAccount',
    ValidateCredentials: HOST_URL + BaseUrl + Controller.Settings + 'ValidateCredentials',
    GenerateHostGroupAccountTokenKey: HOST_URL + BaseUrl + Controller.Settings + 'GenerateHostGroupAccountTokenKey',
    SetHostGroupAccountTokenKey: HOST_URL + BaseUrl + Controller.Settings + 'SetHostGroupAccountTokenKey',
    DeleteScannedEndpoint: HOST_URL + BaseUrl + Controller.Settings + 'DeleteScannedEndpoint',
    AddScannedEndpoint: HOST_URL + BaseUrl + Controller.Settings + 'AddScannedEndpoint',
    SwitchScannedEndpointsGroup: HOST_URL + BaseUrl + Controller.Settings + 'SwitchScannedEndpointsGroup',
    GetHostsPopulation: HOST_URL + BaseUrl + Controller.Settings + 'GetHostsPopulation',
    DeleteGroupScheduling: HOST_URL + BaseUrl + Controller.Settings + 'DeleteGroupScheduling',
    AddGroupScheduling: HOST_URL + BaseUrl + Controller.Settings + 'AddGroupScheduling',
    UpdateGroupScheduling: HOST_URL + BaseUrl + Controller.Settings + 'UpdateGroupScheduling',
    SyncAD: HOST_URL + BaseUrl + Controller.Settings + 'SyncAD',
    GetSystemInfo: HOST_URL + BaseUrl + Controller.Settings + 'GetSystemInfo',
    GetPlaybookSettings: HOST_URL + BaseUrl + Controller.Settings + 'GetPlaybookSettings',
    SavePlaybookSettings: HOST_URL + BaseUrl + Controller.Settings + 'SavePlaybookSettings',
    GetAlertsSettings: HOST_URL + BaseUrl + Controller.Settings + 'GetAlertsSettings',

    GetExternalDistributionEmailsList: HOST_URL + BaseUrl + 'ExternalEmailRecipients/GetExternalDistributionEmailsList',
    UpdateExternalDistributionEmailsList:
      HOST_URL + BaseUrl + 'ExternalEmailRecipients/UpdateExternalDistributionEmailsList',

    SaveAlertsSettings: HOST_URL + BaseUrl + Controller.Settings + 'SaveAlertsSettings',
    GetHostsByKey: HOST_URL + BaseUrl + Controller.Settings + 'GetHostsByKey',
    RemoveHostFromAutoScanAlert: HOST_URL + BaseUrl + Controller.Settings + 'RemoveHostFromAutoScanAlert',
    AddHostToAutoScanAlert: HOST_URL + BaseUrl + Controller.Settings + 'AddHostToAutoScanAlert',
    GetAnalysisSettings: HOST_URL + BaseUrl + Controller.Settings + 'GetAnalysisSettings',
    SaveAnalysisSettings: HOST_URL + BaseUrl + Controller.Settings + 'SaveAnalysisSettings',

    GetAllWindowsPatches: HOST_URL + BaseUrl + Controller.Settings + 'GetAllWindowsPatches',
    UpdateWindowsPatches: HOST_URL + BaseUrl + Controller.Settings + 'UpdateWindowsPatches',
    ClearWindowsPatches: HOST_URL + BaseUrl + Controller.Settings + 'ClearWindowsPatches',

    GetAllRiskyApplications: HOST_URL + BaseUrl + Controller.Settings + 'GetAllRiskyApplications',
    UpdateRiskyApplications: HOST_URL + BaseUrl + Controller.Settings + 'UpdateRiskyApplications',
    ClearRiskyApplications: HOST_URL + BaseUrl + Controller.Settings + 'ClearRiskyApplications',

    GetAllOutdatedApplications: HOST_URL + BaseUrl + Controller.Settings + 'GetAllOutdatedApplications',
    AddOutdatedApplication: HOST_URL + BaseUrl + Controller.Settings + 'AddOutdatedApplication',
    UpdateOutdatedApplication: HOST_URL + BaseUrl + Controller.Settings + 'UpdateOutdatedApplication',
    DeleteOutdatedApplication: HOST_URL + BaseUrl + Controller.Settings + 'DeleteOutdatedApplication',

    GetAllRunningApplications: HOST_URL + BaseUrl + Controller.Settings + 'GetAllRunningApplications',
    DeleteRunningApplication: HOST_URL + BaseUrl + Controller.Settings + 'DeleteRunningApplication',
    AddRunningApplication: HOST_URL + BaseUrl + Controller.Settings + 'AddRunningApplication',
    UpdateRunningApplication: HOST_URL + BaseUrl + Controller.Settings + 'UpdateRunningApplication',

    //Threat hunting
    GetThreatHuntingData: HOST_URL + BaseUrl + Controller.ThreatHunting + 'GetThreatHuntingData',
    SaveThSearchCriteria: HOST_URL + BaseUrl + Controller.ThreatHunting + 'SaveSearchCriteria',
    RemoveThSearchCriteria: HOST_URL + BaseUrl + Controller.ThreatHunting + 'RemoveSearchCriteria',
    GetThreatHuntingMetaData: HOST_URL + BaseUrl + Controller.ThreatHunting + 'GetTreatHuntingMeta',
    SaveThreatHuntingMetaData: HOST_URL + BaseUrl + Controller.ThreatHunting + 'SaveTreatHuntingMeta',
    GetStopThreatHunting: HOST_URL + BaseUrl + Controller.ThreatHunting + 'StopCurrent',
    GetRestartThreatHunting: HOST_URL + BaseUrl + Controller.ThreatHunting + 'RestartCurrent',
    GetClearCriteriaThreatHunting: HOST_URL + BaseUrl + Controller.ThreatHunting + 'CleanSearchCriteria',
    //decoy files
    GetDecoyTableData: HOST_URL + BaseUrl + Controller.SettingsDecoy + 'GetDecoyTableData',
    GetDecoyFileGroupsAndFolder: HOST_URL + BaseUrl + Controller.SettingsDecoy + 'GetDecoyFileGroupsAndFolder',
    UpdateDecoyFileGroupsAndFolder: HOST_URL + BaseUrl + Controller.SettingsDecoy + 'UpdateDecoyFileGroupsAndFolders',
    UpdateDecoyFileToGroups: HOST_URL + BaseUrl + Controller.SettingsDecoy + 'UpdateDecoyFileToGroups',
    GenerateDecoyTestFile: HOST_URL + BaseUrl + Controller.SettingsDecoy + 'GenerateDecoyTestFile',
    SaveDecoyNewFile: HOST_URL + BaseUrl + Controller.SettingsDecoy + 'SaveDecoyNewFile',
    GetHostsGroupWithDecoyEnabled: HOST_URL + BaseUrl + Controller.SettingsDecoy + 'GetDecoyFilesGroups',
    GetDecoyFilesGroupsById: HOST_URL + BaseUrl + Controller.SettingsDecoy + 'GetDecoyFilesGroupsById',

    //whitelisting
    GetWhitelistingCriteriaData: HOST_URL + BaseUrl + Controller.SettingsWhitelisting + 'GetWhitelistCriteriaData',
    GetWhitelistingRuleAlerts: '/' + Controller.SettingsWhitelisting + 'GetWhitelistRulesAlerts',
    GetWhitelistingRuleTypes: HOST_URL + BaseUrl + Controller.SettingsWhitelisting + 'GetWhitelistRulesTypes',
    SaveNewRule: HOST_URL + BaseUrl + Controller.SettingsWhitelisting + 'SaveNewRule',
    RemoveRule: HOST_URL + BaseUrl + Controller.SettingsWhitelisting + 'RemoveRule',
    GetAllowlistProfileListItems: HOST_URL + BaseUrl + Controller.SettingsWhitelisting + 'GetAllowlistProfileListItems',
    GetWhitelistingRulesProfiles: '/' + Controller.SettingsWhitelisting + 'GetWhitelistRulesProfiles',
    ExportWhitelistProfiles: `${BaseUrl}${Controller.SettingsWhitelisting}ExportWhitelistProfiles`,
    ImportWhitelistProfiles: `${BaseUrl}${Controller.SettingsWhitelisting}ImportWhitelistProfiles`,
    GetWhitelistingRulesProfile: '/' + Controller.SettingsWhitelisting + 'GetWhitelistRulesProfile',
    GetWhitelistingRulesProfileByAlertId:
      HOST_URL + BaseUrl + Controller.SettingsWhitelisting + 'GetWhitelistRulesProfileByAlert',
    AddWhitelistingRulesProfile: '/' + Controller.SettingsWhitelisting + 'AddWhitelistRulesProfile',
    UpdateWhitelistingRulesProfile: '/' + Controller.SettingsWhitelisting + 'UpdateWhitelistRulesProfile',
    RemoveProfile: '/' + Controller.SettingsWhitelisting + 'RemoveProfile',
    GetWhitelistingRulesScanGroups: HOST_URL + BaseUrl + Controller.SettingsWhitelisting + 'GetScanGroups',
    GetWhitelistingRulesHosts: '/' + Controller.SettingsWhitelisting + 'GetHosts',

    GetWhitelistProfilesFromSite: '/' + Controller.SettingsWhitelisting + 'GetWhitelistRulesProfilesFromSites',
    GetWhitelistingRulesSiteProfile: '/' + Controller.SettingsWhitelisting + 'GetSiteWhitelistRulesProfile',
    // Exclusion
    GetExclusionProfileListItems: `${BaseUrl}${Controller.SettingsExclusion}GetExclusionProfileListItems`,
    GetExclusionRulesProfiles: '/' + Controller.SettingsExclusion + 'GetExclusionProfiles',
    ExportExclusionProfiles: `${BaseUrl}${Controller.SettingsExclusion}ExportExclusionProfiles`,
    ImportExclusionProfiles: `${BaseUrl}${Controller.SettingsExclusion}ImportExclusionProfiles`,
    GetExclusionRulesProfile: '/' + Controller.SettingsExclusion + 'GetExclusionsProfile',
    AddExclusionRulesProfile: '/' + Controller.SettingsExclusion + 'AddExclusionProfile',
    UpdateExclusionRulesProfile: '/' + Controller.SettingsExclusion + 'UpdateExclusionProfile',
    RemoveExclusionProfile: '/' + Controller.SettingsExclusion + 'RemoveExclusionProfile',

    GetExclusionProfilesFromSite: '/' + Controller.SettingsExclusion + 'GetExclusionRulesProfilesFromSites',
    GetExclusionRulesSiteProfile: '/' + Controller.SettingsExclusion + 'GetSiteExclusionRulesProfile',

    // Windows Events Profile
    GetWindowsEventsProfiles: HOST_URL + BaseUrl + Controller.WindowsEventsProfile + 'GetWindowsEventsProfiles',
    GetWindowsEventsProfile: HOST_URL + BaseUrl + Controller.WindowsEventsProfile + 'GetWindowsEventsProfile',
    AddWindowsEventsProfile: HOST_URL + BaseUrl + Controller.WindowsEventsProfile + 'AddWindowsEventsProfile',
    UpdateWindowsEventsProfile: HOST_URL + BaseUrl + Controller.WindowsEventsProfile + 'UpdateWindowsEventsProfile',
    RemoveWindowsEventsProfile: HOST_URL + BaseUrl + Controller.WindowsEventsProfile + 'RemoveWindowsEventsProfile',

    // Storage Devices Profile
    GetStorageDevicesProfiles: HOST_URL + BaseUrl + Controller.StorageDevicesProfile + 'GetStorageDevicesProfiles',
    GetStorageDevicesProfile: HOST_URL + BaseUrl + Controller.StorageDevicesProfile + 'GetStorageDevicesProfile',
    AddStorageDevicesProfile: HOST_URL + BaseUrl + Controller.StorageDevicesProfile + 'AddStorageDevicesProfile',
    UpdateStorageDevicesProfile: HOST_URL + BaseUrl + Controller.StorageDevicesProfile + 'UpdateStorageDevicesProfile',
    RemoveStorageDevicesProfile: HOST_URL + BaseUrl + Controller.StorageDevicesProfile + 'RemoveStorageDevicesProfile',
    GetStorageDevicesVendorsAndProducts:
      HOST_URL + BaseUrl + Controller.StorageDevicesProfile + 'GetStorageDevicesVendorsAndProducts',
    //QuickStorageDeviceExceptionTab
    GetStorageDevicesProfilesWithUnAuthorizedClassification:
      HOST_URL + BaseUrl + Controller.StorageDevicesProfile + 'GetStorageDevicesProfilesWithUnAuthorizedClassification',
    AddStorageDeviceExceptionToProfiles:
      HOST_URL + BaseUrl + Controller.StorageDevicesProfile + 'AddExclusionRuleToProfiles',
    GetStorageDeviceIdFromAlert: HOST_URL + BaseUrl + Controller.StorageDevicesProfile + 'GetStorageDeviceIdFromAlert',

    ImportGroupHosts: HOST_URL + BaseUrl + Controller.Settings + 'ImportGroupHosts',
    ExportGroupHosts: HOST_URL + BaseUrl + Controller.Settings + 'ExportGroupHosts',

    GetIsGlobalMode: HOST_URL + BaseUrl + Controller.Settings + 'GetIsGlobalMode',

    GetAllPlayBookTemplates: HOST_URL + BaseUrl + Controller.PlayBooks + 'GetAllPlayBookTemplates',
    AddPlayBookTemplate: HOST_URL + BaseUrl + Controller.PlayBooks + 'AddPlayBookTemplate',
    UpdatePlayBookTemplate: HOST_URL + BaseUrl + Controller.PlayBooks + 'UpdatePlayBookTemplate',
    DeletePlayBookTemplate: HOST_URL + BaseUrl + Controller.PlayBooks + 'DeletePlayBookTemplate',

    // Custom Remediations Execution Servers
    GetCustomRemediationExecutionServers:
      HOST_URL + BaseUrl + Controller.CustomRemediationExecutionServers + 'GetCustomRemediationExecutionServers',
    GetCustomRemediationHasAvailableExecutionServers:
      HOST_URL +
      BaseUrl +
      Controller.CustomRemediationExecutionServers +
      'GetCustomRemediationHasAvailableExecutionServers',
    UpdateCustomRemediationExecutionServers:
      HOST_URL + BaseUrl + Controller.CustomRemediationExecutionServers + 'UpdateCustomRemediationExecutionServers',

    //File Monitor
    GetFileMonitorProfiles: HOST_URL + BaseUrl + Controller.SettingsFileMonitor + 'GetFileMonitorProfiles',
    GetFileMonitorProfile: HOST_URL + BaseUrl + Controller.SettingsFileMonitor + 'GetFileMonitorProfile',
    AddFileMonitorProfile: HOST_URL + BaseUrl + Controller.SettingsFileMonitor + 'AddFileMonitorProfile',
    UpdateFileMonitorProfile: HOST_URL + BaseUrl + Controller.SettingsFileMonitor + 'UpdateFileMonitorProfile',
    RemoveFileMonitorProfile: HOST_URL + BaseUrl + Controller.SettingsFileMonitor + 'RemoveFileMonitorProfile',

    //deception user
    AddDeceptionUserConfiguration: HOST_URL + BaseUrl + Controller.DeceptionUser + 'AddDeceptionUser',
    UpdateDeceptionUserConfiguration: HOST_URL + BaseUrl + Controller.DeceptionUser + 'UpdateDeceptionUser',
    RemoveDeceptionUserConfiguration: HOST_URL + BaseUrl + Controller.DeceptionUser + 'DeleteDeceptionUser',
    DeceptionUserGetScanGroups: HOST_URL + BaseUrl + Controller.DeceptionUser + 'GetScanGroups',
    getAllDeceptionUserConfiguration: HOST_URL + BaseUrl + Controller.DeceptionUser + 'GetAllDeceptionUsers',
    getDeceptionUsersToDeny: HOST_URL + BaseUrl + Controller.DeceptionUser + 'GetDeceptionUsersToDeny',
    //decoy network
    GetDecoyNetworkConfigurationForGroup:
      HOST_URL + BaseUrl + Controller.SettingsDecoyNetwork + 'GetDecoyNetworkConfigurationForGroup',
    GetDecoyNetworkMaxDecoyHostsForEPS:
      HOST_URL + BaseUrl + Controller.SettingsDecoyNetwork + 'GetDecoyNetworkMaxDecoyHostsForEPS',
    GetDecoyNetworkOsVersions: HOST_URL + BaseUrl + Controller.SettingsDecoyNetwork + 'GetDecoyNetworkOsVersions',
    UpdateDecoyNetworkMaxDecoyHostsForEPS:
      HOST_URL + BaseUrl + Controller.SettingsDecoyNetwork + 'UpdateDecoyNetworkMaxDecoyHostsForEPS',
    ImportDecoyHostsList: HOST_URL + BaseUrl + Controller.SettingsDecoyNetwork + 'ImportDecoyHostsList',
    DeleteAllDecoyNetworkConfigurationForGroup:
      HOST_URL + BaseUrl + Controller.SettingsDecoyNetwork + 'DeleteAllDecoyNetworkConfigurationForGroup',
    DeleteDecoyNetworkConfigurationByIds:
      HOST_URL + BaseUrl + Controller.SettingsDecoyNetwork + 'DeleteDecoyNetworkConfigurationByIds',
    AddDecoyHostToGroup: HOST_URL + BaseUrl + Controller.SettingsDecoyNetwork + 'AddDecoyHostToGroup',
    GetConfigurationCSVTemplate: HOST_URL + BaseUrl + Controller.SettingsDecoyNetwork + 'GetConfigurationCSVTemplate',

    //SSL Pinning
    GetEpsCertificates: HOST_URL + BaseUrl + Controller.SettingsEPSCertificates + 'GetEpsCertificates',
    ChangeEpsCertificateStatus: HOST_URL + BaseUrl + Controller.SettingsEPSCertificates + 'ChangeEpsCertificateStatus',
    AddNewEpsCertificate: HOST_URL + BaseUrl + Controller.SettingsEPSCertificates + 'AddNewEpsCertificate',

    // user roles
    GetRoles: HOST_URL + BaseUrl + Controller.Settings + 'GetUserRolesAsync',
    AddUserRole: HOST_URL + BaseUrl + Controller.Settings + 'AddUserRoleAsync',
    ChangeUserRoleAsync: HOST_URL + BaseUrl + Controller.Settings + 'ChangeUserRoleAsync',
    ChangeRolePermissionsAsync: HOST_URL + BaseUrl + Controller.Settings + 'ChangeRolePermissionsAsync',
    DeleteRoleAsync: HOST_URL + BaseUrl + Controller.Settings + 'DeleteRoleAsync',
    ChangeAdIdentityRoleAsync: HOST_URL + BaseUrl + Controller.Settings + 'ChangeAdIdentityRoleAsync'
  },
  WindowsEvents: {
    GetWindowsEventsEntities: BaseUrl + Controller.WindowsEventsProfile + 'GetEntities?',
    GetWindowsEventsEntityFields: BaseUrl + Controller.WindowsEventsProfile + 'GetEntityFields'
  },
  Remediation: {
    //file analysis
    SendToSoc: HOST_URL + BaseUrl + Controller.Remediation + 'SendToSoc',
    InspectFile: HOST_URL + BaseUrl + Controller.Remediation + 'InspectFile',

    //file remediation
    Kill: HOST_URL + BaseUrl + Controller.Remediation + 'Kill',
    VerifyExistence: HOST_URL + BaseUrl + Controller.Remediation + 'VerifyExistence',
    PullFile: HOST_URL + BaseUrl + Controller.Remediation + 'PullFile',
    QuarantineFile: HOST_URL + BaseUrl + Controller.Remediation + 'QuarantineFile',
    Unquarantine: HOST_URL + BaseUrl + Controller.Remediation + 'Unquarantine',
    DeleteFile: HOST_URL + BaseUrl + Controller.Remediation + 'DeleteFile',
    GetFileRemediateStatus: HOST_URL + BaseUrl + Controller.Files + 'GetFileRemediateStatus',
    //user remediation
    EnableUser: HOST_URL + BaseUrl + Controller.Remediation + 'EnableUser',
    DisableUser: HOST_URL + BaseUrl + Controller.Remediation + 'DisableUser',
    GetUserRemediateStatus: HOST_URL + BaseUrl + Controller.Users + 'GetUserRemediateStatus',
    //Active directory user remediation
    EnableAdUser: HOST_URL + BaseUrl + Controller.Remediation + 'EnableAdUser',
    DisableAdUser: HOST_URL + BaseUrl + Controller.Remediation + 'DisableAdUser',

    //host remediation
    StartScan: HOST_URL + BaseUrl + Controller.Remediation + 'StartScan',
    StartScanFromHosts: HOST_URL + BaseUrl + Controller.Remediation + 'StartScanFromHosts',
    ShutDown: HOST_URL + BaseUrl + Controller.Remediation + 'ShutDown',
    Restart: HOST_URL + BaseUrl + Controller.Remediation + 'Restart',
    ChangeIp: HOST_URL + BaseUrl + Controller.Remediation + 'ChangeIp',
    BlockTraffic: HOST_URL + BaseUrl + Controller.Remediation + 'BlockTraffic',
    RunCommand: HOST_URL + BaseUrl + Controller.Remediation + 'RunCommand',
    RunCommandOnAllHosts: HOST_URL + BaseUrl + Controller.Remediation + 'RunCommandOnAllHosts',
    PullFileByPath: HOST_URL + BaseUrl + Controller.Remediation + 'PullFileByPath',
    RunFileOnHost: HOST_URL + BaseUrl + Controller.Remediation + 'RunFileOnHost',
    RunFileOnAllHosts: HOST_URL + BaseUrl + Controller.Remediation + 'RunFileOnAllHosts',
    DisableService: HOST_URL + BaseUrl + Controller.Remediation + 'DisableService',
    DisableTask: HOST_URL + BaseUrl + Controller.Remediation + 'DisableTask',
    DeleteService: HOST_URL + BaseUrl + Controller.Remediation + 'DeleteService',
    DeleteTask: HOST_URL + BaseUrl + Controller.Remediation + 'DeleteTask',
    Isolate: HOST_URL + BaseUrl + Controller.Remediation + 'Isolate',
    UnIsolate: HOST_URL + BaseUrl + Controller.Remediation + 'UnIsolate',
    StartFullAvScan: HOST_URL + BaseUrl + Controller.Remediation + 'StartFullAvScan',
    CancelRunningAvScan: HOST_URL + BaseUrl + Controller.Remediation + 'CancelRunningAvScan',
    GetHostRemediateStatus: HOST_URL + BaseUrl + Controller.Hosts + 'GetHostRemediateStatus',
    GetPulledFileByPath: HOST_URL + BaseUrl + Controller.Hosts + 'GetPulledFileByPath',
    GetHostActionDetailedStatusInfo: HOST_URL + BaseUrl + Controller.Hosts + 'GetHostActionDetailedStatusInfo',
    ClearCustomEpsArgs: HOST_URL + BaseUrl + Controller.Hosts + 'ClearCustomEpsArgs',
    SetCustomEpsArgs: HOST_URL + BaseUrl + Controller.Hosts + 'SetCustomEpsArgs',
    RunRollback: HOST_URL + BaseUrl + Controller.Remediation + 'RunRollback',

    //network remediate
    BlockTrafficNetowrk: HOST_URL + BaseUrl + Controller.Remediation + 'BlockTrafficNetowrk',
    RouteByDns: HOST_URL + BaseUrl + Controller.Remediation + 'RouteByDns',
    GetNetworkRemediateStatus: HOST_URL + BaseUrl + Controller.Network + 'GetNetworkRemediateStatus',

    //auto remediation
    GetAutoRemediate: HOST_URL + BaseUrl + Controller.Remediation + 'GetAutoRemediate',
    SetAutoRemediateStatus: HOST_URL + BaseUrl + Controller.Remediation + 'SetAutoRemediateStatus',
    GetHostsGroups: HOST_URL + BaseUrl + Controller.Remediation + 'GetHostsGroups',
    GetHostsToMatch: HOST_URL + BaseUrl + Controller.Remediation + 'GetHostsToMatch',
    GetAllOs: HOST_URL + BaseUrl + Controller.Remediation + 'GetAllOs',
    SaveGroup: HOST_URL + BaseUrl + Controller.Remediation + 'SaveGroup',
    SaveAutoRemediation: HOST_URL + BaseUrl + Controller.Remediation + 'SaveAutoRemediation',
    DeleteAutoRemediations: HOST_URL + BaseUrl + Controller.Remediation + 'DeleteAutoRemediations'
  },
  CustomRemediation: {
    //custom remediation
    GetAllCustomRemediateTemplateFull:
      HOST_URL + BaseUrl + Controller.CustomRemediation + 'GetAllCustomRemediateTemplateFull',
    DeleteCustomRemediation: HOST_URL + BaseUrl + Controller.CustomRemediation + 'DeleteCustomRemediation',
    AddCustomRemediateTemplate: HOST_URL + BaseUrl + Controller.CustomRemediation + 'AddCustomRemediateTemplate',
    UpdateCustomRemediateTemplate: HOST_URL + BaseUrl + Controller.CustomRemediation + 'UpdateCustomRemediateTemplate',
    UploadExecutionFile: HOST_URL + BaseUrl + Controller.CustomRemediation + 'UploadExecutionFile',
    UploadExecutionFolder: HOST_URL + BaseUrl + Controller.CustomRemediation + 'UploadExecutionFolder',
    GetCustomRemediateTemplatesByEntities:
      HOST_URL + BaseUrl + Controller.CustomRemediation + 'GetCustomRemediateTemplatesByEntities',
    GetCustomRemediateJavaScriptByTemplateIdAndIdentifier:
      HOST_URL + BaseUrl + Controller.CustomRemediation + 'GetCustomRemediateJavaScriptByTemplateIdAndIdentifier',
    InitializeCustomRemediationOnFiles:
      HOST_URL + BaseUrl + Controller.CustomRemediation + 'InitializeCustomRemediationOnFiles',
    InitializeCustomRemediationOnHost:
      HOST_URL + BaseUrl + Controller.CustomRemediation + 'InitializeCustomRemediationOnHost',
    InitializeCustomRemediationOnUser:
      HOST_URL + BaseUrl + Controller.CustomRemediation + 'InitializeCustomRemediationOnUser',
    InitializeCustomRemediationOnNetwork:
      HOST_URL + BaseUrl + Controller.CustomRemediation + 'InitializeCustomRemediationOnNetwork',
    GetRemediationFile: HOST_URL + BaseUrl + Controller.CustomRemediation + 'GetRemediationFile',
    DeleteRemediationFile: HOST_URL + BaseUrl + Controller.CustomRemediation + 'DeleteRemediationFile',
    GetRemediationFileText: HOST_URL + BaseUrl + Controller.CustomRemediation + 'GetRemediationFileText'
  },
  Vault: {
    GetActiveVaultObjects: HOST_URL + BaseUrl + Controller.Vault + 'GetActiveVaultObjects',
    GetAllVaultObjects: HOST_URL + BaseUrl + Controller.Vault + 'GetAllVaultObjects',

    DeleteVaultVariableObject: HOST_URL + BaseUrl + Controller.Vault + 'DeleteVaultVariableObject',
    DeleteVaultObject: HOST_URL + BaseUrl + Controller.Vault + 'DeleteVaultObject',

    UpdateVaultObjectVariable: HOST_URL + BaseUrl + Controller.Vault + 'UpdateVaultObjectVariable',
    UpdateVaultObject: HOST_URL + BaseUrl + Controller.Vault + 'UpdateVaultObject',

    AddVaultObjectVariable: HOST_URL + BaseUrl + Controller.Vault + 'AddVaultObjectVariable',
    AddVaultObject: HOST_URL + BaseUrl + Controller.Vault + 'AddVaultObject'
  },
  Search: {
    GetHostDetails: HOST_URL + BaseUrl + Controller.Search + 'GetHostDetails',
    GetMultipleHostDetails: HOST_URL + BaseUrl + Controller.Search + 'GetMultipleHostDetails',
    GetEntities: HOST_URL + BaseUrl + Controller.Search + 'GetEntities',
    GetEntityFields: HOST_URL + BaseUrl + Controller.Search + 'GetEntityFields'
  },
  PlayBooks: {
    InitializePlayBookAction: HOST_URL + BaseUrl + Controller.PlayBooks + 'InitializePlayBookAction',
    GetPlayBookInstanceItems: HOST_URL + BaseUrl + Controller.PlayBooks + 'GetPlayBookInstanceItems',
    GetPlayBookInstanceItemsByAutoRemId:
      HOST_URL + BaseUrl + Controller.PlayBooks + 'GetPlayBookInstanceItemsByAutoRemId',
    GetAllPlaybookTriggerIdentifiers:
      HOST_URL + BaseUrl + Controller.PlayBooks + 'GetAllPlaybookTriggerIdentifiersAsync'
  },
  Actions: {},
  CisoKit: {
    GetAllCisoKitsConnection: HOST_URL + BaseUrl + Controller.CisoKit + 'GetAllCisoKitsConnectionByLoggedInUser',
    CreateCisoKit: HOST_URL + BaseUrl + Controller.CisoKit + 'AddOrUpdateCISOKitConnection',
    UpdateCisoKit: HOST_URL + BaseUrl + Controller.CisoKit + 'UpdateCisoKit',
    DeleteCisoKitConnection: HOST_URL + BaseUrl + Controller.CisoKit + 'DisableCISOKitConnection',
    IsCisoKitEnabled: HOST_URL + BaseUrl + Controller.CisoKit + 'IsCisoKitEnabled'
  },
  Scanner: {
    GenerateEPSByGroupAsync: HOST_URL + BaseUrl + Controller.Scanner + 'GenerateEPSByGroupAsync'
  },
  GlobalMode: {
    Settings: {
      GetIsGlobalMode: HOST_URL + BaseUrlGlobalMode + Controller.Settings + 'GetIsGlobalMode',
      SelectMasterSlave: HOST_URL + BaseUrlGlobalMode + Controller.Settings + 'SelectMasterSlave',
      GetMasterSlaves: HOST_URL + BaseUrlGlobalMode + Controller.Settings + 'GetMasterSlaves',
      getAllUsers: HOST_URL + BaseUrlGlobalMode + Controller.Settings + 'GetAllUsers',
      GetAuthenticationMode: HOST_URL + BaseUrlGlobalMode + Controller.Settings + 'GetAuthenticationMode',
      GetEnabledADIdentities: HOST_URL + BaseUrlGlobalMode + Controller.Settings + 'GetEnabledADIdentities',
      GetActiveDirectoryConnectionsGlobal: HOST_URL + BaseUrlGlobalMode + Controller.Settings + 'GetADSerivces',
      GetActiveDirectoryGroupsByDomain: HOST_URL + BaseUrlGlobalMode + Controller.Settings + 'GetAdGroupsByDomain',
      AddEnabledADIdentity: HOST_URL + BaseUrlGlobalMode + Controller.Settings + 'AddEnabledADIdentities',

      GetMfaStatusByUserId: HOST_URL + BaseUrlGlobalMode + Controller.Settings + 'GetMfaStatusByUserId',
      IsMfaEnabled: HOST_URL + BaseUrlGlobalMode + Controller.Settings + 'IsMfaEnabled',
      IsAddUsernameInEmailFormat: HOST_URL + BaseUrlGlobalMode + Controller.Settings + 'IsAddUsernameInEmailFormat',
      ChangeUserMfaSettings: HOST_URL + BaseUrlGlobalMode + Controller.Settings + 'ChangeUserMfaSettings',
      GetTags: HOST_URL + BaseUrlGlobalMode + Controller.Settings + 'getTags',
      GetClientTypes: HOST_URL + BaseUrlGlobalMode + Controller.Settings + 'GetClientTypes',
      GetEntities: HOST_URL + BaseUrlGlobalMode + Controller.Settings + 'GetEntities?',
      GetEntityFields: HOST_URL + BaseUrlGlobalMode + Controller.Settings + 'GetEntityFields',
      GetAllSlavesSystemStatus: HOST_URL + BaseUrlGlobalMode + Controller.Settings + 'GetSlavesSystemStatus',
      GetAllSlaveSites: HOST_URL + BaseUrlGlobalMode + Controller.Settings + 'GetAllSlaveSites',
      CreateAutoDeployedSlave: HOST_URL + BaseUrlGlobalMode + Controller.Settings + 'CreateAutoDeployedSlave',
      GetMasterVersion: HOST_URL + BaseUrlGlobalMode + Controller.Settings + 'GetMasterVersion',
      GetScanGroupsForAllSlaveSitesForFeature:
        HOST_URL + BaseUrlGlobalMode + Controller.SettingsScanGroups + 'GetScanGroupsForAllSlaveSitesForFeature',
      UpdateScanGroupForSlaveSite:
        HOST_URL + BaseUrlGlobalMode + Controller.SettingsScanGroups + 'UpdateScanGroupForSlaveSite',
      UpdateSlaveSiteScanGroups:
        HOST_URL + BaseUrlGlobalMode + Controller.SettingsScanGroups + 'UpdateSlaveSiteScanGroups',
      UpdateScanGroupsForAllSlaveSite:
        HOST_URL + BaseUrlGlobalMode + Controller.SettingsScanGroups + 'UpdateScanGroupsForAllSlaveSite',

      GetSiemSettingsForAllSlaveSites:
        HOST_URL + BaseUrlGlobalMode + Controller.SettingsAlerts + 'GetSiemSettingsForAllSlaveSites',
      SaveSiemSlaveSiteSettings:
        HOST_URL + BaseUrlGlobalMode + Controller.SettingsAlerts + 'UpdateSiemSettingsForSlaveSite',
      UpdateSiemSettingsForSlaveSite:
        HOST_URL + BaseUrlGlobalMode + Controller.SettingsAlerts + 'UpdateSiemSettingsForSlaveSite',
      UpdateSiemSettingsForAllSlaveSites:
        HOST_URL + BaseUrlGlobalMode + Controller.SettingsAlerts + 'UpdateSiemSettingsForAllSites',
      GetSiemSettingsForGlobalManagement:
        HOST_URL + BaseUrlGlobalMode + Controller.SettingsAlerts + 'GetSiemSettingsForGlobalManagement',
      UpdateSiemSettingsForGlobalManagement:
        HOST_URL + BaseUrlGlobalMode + Controller.SettingsAlerts + 'UpdateSiemSettingsForGlobalManagement',
      UpdateSiteDetails: HOST_URL + BaseUrlGlobalMode + Controller.Settings + 'UpdateSiteDetails',
      CreateSlaveSite: HOST_URL + BaseUrlGlobalMode + Controller.Settings + 'CreateSlaveSite',
      RemoveSlaveSite: HOST_URL + BaseUrlGlobalMode + Controller.Settings + 'RemoveSlaveSite',
      GetMsspStats: HOST_URL + BaseUrlGlobalMode + Controller.Settings + 'GetMsspStats',
      GetClientTypeById: HOST_URL + BaseUrlGlobalMode + Controller.Settings + 'GetClientTypeById',
      GetLicenseStatusById: HOST_URL + BaseUrlGlobalMode + Controller.Settings + 'GetLicenseStatus',
      GetLicenseStatusByIdGQL: HOST_URL + BaseUrlGlobalMode + Controller.Settings + 'GetLicenseStatusGQL',
      GetUserHasPermissionAllMsspSites:
        HOST_URL + BaseUrlGlobalMode + Controller.Settings + 'GetUserHasPermissionAllMsspSites'
    },
    ClientSettings: {
      GetClientConfigKeyForALLSites:
        HOST_URL + BaseUrlGlobalMode + Controller.ClientSettings + 'GetClientConfigKeyForALLSites',
      UpdateConfigKeySite: HOST_URL + BaseUrlGlobalMode + Controller.ClientSettings + 'UpdateConfigKeySite',
      UpdateConfigKeyForAllSlaveSite:
        HOST_URL + BaseUrlGlobalMode + Controller.ClientSettings + 'UpdateConfigKeyForAllSlaveSite'
    },
    Search: {
      GetEntityFields: HOST_URL + BaseUrlGlobalMode + Controller.Search + 'GetEntityFields',
      GetEntities: HOST_URL + BaseUrlGlobalMode + Controller.Search + 'GetEntities',
      SearchEntitiesAdvanced: HOST_URL + BaseUrlGlobalMode + Controller.Search + 'SearchEntitiesAdvanced',
      SaveSearch: HOST_URL + BaseUrlGlobalMode + Controller.Search + 'SaveSearch',
      SavePolicy: HOST_URL + BaseUrlGlobalMode + Controller.Search + 'SavePolicy',
      RemovePolicy: HOST_URL + BaseUrlGlobalMode + Controller.Search + 'RemovePolicy',
      GetSavedSearchesForEntity: HOST_URL + BaseUrlGlobalMode + Controller.Search + 'GetSavedSearchesForEntity',
      GetSavedPoliciesForEntity: HOST_URL + BaseUrlGlobalMode + Controller.Search + 'GetSavedPoliciesForEntity',
      GetSavedSearchWithCriteria: HOST_URL + BaseUrlGlobalMode + Controller.Search + 'GetSavedSearchWithCriteria',
      RemoveSavedSearch: HOST_URL + BaseUrlGlobalMode + Controller.Search + 'RemoveSavedSearch',
      ExportSearchToExcel: HOST_URL + BaseUrlGlobalMode + Controller.Search + 'ExportSearchToExcel',
      GetFavoriteSearches: HOST_URL + BaseUrlGlobalMode + Controller.Search + 'GetFavoriteSearches',
      AddSearchToFavorites: HOST_URL + BaseUrlGlobalMode + Controller.Search + 'AddSearchToFavorites',
      RemoveSearchFromFavorites: HOST_URL + BaseUrlGlobalMode + Controller.Search + 'RemoveSearchFromFavorites',
      GetHostsMap: HOST_URL + BaseUrlGlobalMode + Controller.Search + 'GetHostsMap'
    },
    CisoKit: {
      GetAllCisoKitsConnection:
        HOST_URL + BaseUrlGlobalMode + Controller.CisoKit + 'GetAllCisoKitsConnectionByLoggedInUser',
      CreateCisoKit: HOST_URL + BaseUrlGlobalMode + Controller.CisoKit + 'AddOrUpdateCISOKitConnection',
      UpdateCisoKit: HOST_URL + BaseUrlGlobalMode + Controller.CisoKit + 'UpdateCisoKit',
      DeleteCisoKitConnection: HOST_URL + BaseUrlGlobalMode + Controller.CisoKit + 'DisableCISOKitConnection',
      IsCisoKitEnabled: HOST_URL + BaseUrlGlobalMode + Controller.CisoKit + 'IsCisoKitEnabled'
    },
    Users: {
      GetUserPermissions: HOST_URL + BaseUrlGlobalMode + Controller.Users + 'GetUserPermissions',
      ChangeUserPermission: HOST_URL + BaseUrlGlobalMode + Controller.Users + 'ChangeUserPermission',
      GetSitesByLoggedInUserSitesPermissions:
        HOST_URL + BaseUrlGlobalMode + Controller.Users + 'GetSitesByLoggedInUserSitesPermissions',
      GetUsersByLoggedInUser: HOST_URL + BaseUrlGlobalMode + Controller.Users + 'GetUsersByLoggedInUser',

      AddSiteToUser: HOST_URL + BaseUrlGlobalMode + Controller.Users + 'AddSiteToUser',
      RemoveSiteToUser: HOST_URL + BaseUrlGlobalMode + Controller.Users + 'RemoveSiteToUser',

      DeleteUser: HOST_URL + BaseUrlGlobalMode + Controller.Users + 'DeleteUser',
      RemoveEnabledADIdentity: HOST_URL + BaseUrlGlobalMode + Controller.Users + 'RemoveEnabledADIdentity',
      AddEnabledADIdentities: HOST_URL + BaseUrlGlobalMode + Controller.Users + 'AddEnabledADIdentities',
      AddUser: HOST_URL + BaseUrlGlobalMode + Controller.Users + 'AddUser',
      ChangeAdIdentityRoleAsync: HOST_URL + BaseUrlGlobalMode + Controller.Users + 'ChangeAdIdentityRoleAsync',

      ChangeUserEmail: HOST_URL + BaseUrlGlobalMode + Controller.Users + 'ChangeUserEmail',
      ChangeUserPassword: HOST_URL + BaseUrlGlobalMode + Controller.Users + 'ChangeUserPassword',
      ChangeUserRoleAsync: HOST_URL + BaseUrlGlobalMode + Controller.Users + 'ChangeUserRoleAsync',
      DeleteRoleAsync: HOST_URL + BaseUrlGlobalMode + Controller.Users + 'DeleteRoleAsync',
      ChangeRolePermissionsAsync: HOST_URL + BaseUrlGlobalMode + Controller.Users + 'ChangeRolePermissionsAsync',
      ChangeRoleSitesAsync: HOST_URL + BaseUrlGlobalMode + Controller.Users + 'ChangeRoleSitesAsync',
      GetUserRolesAsync: HOST_URL + BaseUrlGlobalMode + Controller.Users + 'GetUserRolesAsync',
      AddUserRoleAsync: HOST_URL + BaseUrlGlobalMode + Controller.Users + 'AddUserRoleAsync',
      AddAllSitesToUser: `${HOST_URL}${BaseUrlGlobalMode}${Controller.Users}AddSitesToUser`,
      RemoveAllSitesToUser: `${HOST_URL}${BaseUrlGlobalMode}${Controller.Users}RemoveAllSitesToUser`
    },
    ProxySettings: {
      GetAllWebProxySettings: HOST_URL + BaseUrlGlobalMode + Controller.WebProxySettings + 'GetAllWebProxySettings',
      DeleteWebProxy: HOST_URL + BaseUrlGlobalMode + Controller.WebProxySettings + 'DeleteWebProxyAsync',
      CreateWebProxy: HOST_URL + BaseUrlGlobalMode + Controller.WebProxySettings + 'CreateWebProxyAsync',
      UpdateWebProxy: HOST_URL + BaseUrlGlobalMode + Controller.WebProxySettings + 'UpdateWebProxyAsync'
    },
    Scanner: {
      GenerateEPSByGroupAsync: HOST_URL + BaseUrlGlobalMode + Controller.Scanner + 'GenerateEPSByGroupAsync',
      IsSiteCreatedAutoDeployAsync: HOST_URL + BaseUrlGlobalMode + Controller.Scanner + 'IsSiteCreatedAutoDeployAsync'
    },
    Billing: {
      GetBillingSettingsByClientIdAsync:
        HOST_URL + BaseUrlGlobalMode + Controller.Billing + 'GetBillingSettingsByClientIdAsync',
      UpdateSiteBillingSettings: HOST_URL + BaseUrlGlobalMode + Controller.Billing + 'UpdateBillingSettingsAsync',
      GetReportByPeriodCycleAsync: HOST_URL + BaseUrlGlobalMode + Controller.Billing + 'GetReportByPeriodCycleAsync'
    },
    EmailRecipients: {
      GetClientEmailRecipientsForALLSitesAsync:
        HOST_URL + BaseUrlGlobalMode + Controller.ClientSettings + 'GetClientEmailRecipientsForALLSitesAsync',
      UpdateEmailRecipientsSiteAsync:
        HOST_URL + BaseUrlGlobalMode + Controller.ClientSettings + 'UpdateEmailRecipientsSiteAsync',
      UpdateEmailRecipientsForAllSitesAsync:
        HOST_URL + BaseUrlGlobalMode + Controller.ClientSettings + 'UpdateEmailRecipientsForAllSitesAsync'
    }
  },
  PlantingUIjs: {
    GetPlantingUiBundle: HOST_URL + BaseUrl + Controller.PlantingUIjs + 'GetPlantingUiBundle'
  },
  ClientLogs: HOST_URL + BaseUrl + Controller.ClientLogger + 'PostClientLogs',
  Customers: {
    Information: HOST_URL + BaseUrl + Controller.Customers + 'information',
    Expiration: HOST_URL + BaseUrl + Controller.Customers + 'expiration'
  }
};
